// UploadComponent
import { useEffect, useRef, useState } from 'react';
import './UploadComponent.css';

const UploadComponent = ({
    label,
    onChange,
    error,
    disabled = false,
    accept,
    multiple = false,
    preview = '',
    style = {},
    ...props
}) => {
    const fileInputRef = useRef(null);
    const [previewUrl, setPreviewUrl] = useState(preview);
    useEffect(() => {
        setPreviewUrl(preview);
    }, [preview]);

    const handleChange = (e) => {
        onChange && onChange(e);
    };

    const handleClick = () => {
        if (!disabled) {
            fileInputRef.current?.click();
        }
    };

    return (
        <div className="upload-container" style={style}>
            <input
                ref={fileInputRef}
                type="file"
                onChange={handleChange}
                disabled={disabled}
                accept={accept}
                multiple={multiple}
                className="upload-input"
                {...props}
            />

            <div className={`upload-wrapper ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`} onClick={handleClick} >
                {previewUrl ? (
                    <img
                        src={previewUrl}
                        alt="Preview"
                        className="upload-preview"
                    />
                ) : (
                    <>
                        <span className="upload-icon">📁</span>

                        {label && (
                            <span className="upload-label-text">
                                {label}
                            </span>
                        )}
                    </>
                )}
            </div>

            {error && (<span className="upload-error"> {error} </span>)}
        </div>
    );
};

export default UploadComponent;